import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

import { AttachmentModel, FileItemModel } from '@models/module/fields/main';
import { SystemModulesEnum } from '@models/module/main/systemModules.enum';
import { FolderFileService } from '@module-instance/services';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoDialogModule } from '@shared/modules';
import { NotificationService } from '@shared/services';
import { UserStore } from '@signal-store/index';
import { FolderTreeComponent } from '../folder-tree.component';

export type FolderTreeDialogData = {
  entityInstanceId: number;
  rootModuleId?: number;
  files?: AttachmentModel[];
};

@Component({
  selector: 'cipo-folder-tree-dialog',
  imports: [
    CipoDialogModule,
    FolderTreeComponent,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    CipoDialogHeaderComponent,
  ],
  templateUrl: './folder-tree-dialog.component.html',
})
export class FolderTreeDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FolderTreeDialogComponent>);
  private notify = inject(NotificationService);
  private folderFileService = inject(FolderFileService);
  data = inject<FolderTreeDialogData>(MAT_DIALOG_DATA);
  private folderTree = viewChild<FolderTreeComponent>('folderTree');
  private userStore = inject(UserStore);

  folderNameControl = new FormControl('');
  selectedNode = signal<FileItemModel>(null);
  driveName = computed(() => {
    if (this.data.entityInstanceId) {
      return this.userStore.menuItemsList()?.find(({ moduleId }) => moduleId === SystemModulesEnum.FileContractManager)
        .name;
    }
    return this.userStore.menuItemsList()?.find(({ moduleId }) => moduleId === SystemModulesEnum.MyCIPODrive).name;
  });

  save() {
    this.folderFileService
      .saveAttachmentsToFolder({
        destinationFolderId: this.selectedNode().id,
        files: this.data.files.map(({ id, note }) => ({ id, note })),
        entityInstanceId: this.data.entityInstanceId,
      })
      .subscribe(() => {
        this.notify.success('folderDialog.fileSaved');
        this.dialogRef.close();
      });
  }

  addFolder() {
    const name = this.folderNameControl.value.trim();
    this.folderFileService.createFolder({ name, parentId: this.selectedNode()?.id ?? -1 }).subscribe(() => {
      this.notify.success('folderDialog.saveFolder');
      this.folderNameControl.setValue('');
      this.folderTree().loadRoots();
    });
  }
}
